


























































































import {Component, Vue, Watch} from "vue-property-decorator";
import DeleteButton from "@/components/datatable/DeleteButton.vue";
import EForm from "@/components/datatable/EForm.vue";
import Number from "@/components/inputs/Number.vue";
import TextField from "@/components/inputs/TextField.vue";
import Id from "@/components/inputs/Id.vue";
import SeoForm from "@/components/forms/SeoForm.vue";
import SeoEntity from "@/entity/SeoEntity";
import {SiteEntity} from "@/entity/SiteEntity";

@Component({
    components: {
        SeoForm,
        DeleteButton,EForm,Number,TextField,Id
    }
})
export default class SeoSettings extends  Vue{
    items : SeoEntity[] = [];
    dialog = false;
    loading = false;
    title:string = "";
    search: string = "";
    baseAction:string = "seo";
    action:string = this.baseAction;
    data : SeoEntity = new SeoEntity();
    /** Üst üste binen yüklemelerde yalnızca sonuncusu listeye yazılır */
    loadToken : number = 0;
    headers = [
        {
            text: "Id",
            align: "start",
            sortable: true,
            value: "seo_id"
        },
        {text: "Kod", value: "code"},
        {text: "Başlık", value: "title"},
        {text: "Keywords", value: "meta_keywords"},
        {text: "Açıklama", value: "meta_description"},
        {text: "Paylaşım görseli", value: "og_image_url", sortable: false},
        {text: "İşlemler", value: "actions", sortable: false}
    ];

    /**
     * Sitenin kullandığı kayıt (Seo::defaultForSite): şubenin seo_id'ye
     * göre ilk kaydı; şubenin kaydı yoksa ilk ortak kayıt.
     */
    get defaultSeoId() : any {
        let siteId = this.$store.getters.activeSiteId;
        if(siteId === null || siteId === undefined){
            const sites : SiteEntity[] = this.$store.getters.sites || [];
            const def = sites.find((s:SiteEntity)=> window.Number(s.is_default) === 1) || sites[0];
            siteId = def ? def.site_id : null;
        }
        const sorted = (this.items || []).slice().sort((a:any, b:any)=> window.Number(a.seo_id) - window.Number(b.seo_id));
        const own = sorted.find((i:any)=> siteId !== null && i.site_id !== null && i.site_id !== undefined
            && String(i.site_id) !== "" && window.Number(i.site_id) === window.Number(siteId));
        const shared = sorted.find((i:any)=> i.site_id === null || i.site_id === undefined || String(i.site_id) === "");
        const chosen : any = own || shared;
        return chosen ? chosen.seo_id : null;
    }

    get exampleTitle() : string {
        const def : any = (this.items || []).find((i:any)=> String(i.seo_id) === String(this.defaultSeoId));
        return def && def.title ? def.title : (this.$store.getters.activeSiteName || "Varsayılan başlık");
    }

    isDefault(item:any) : boolean {
        return this.defaultSeoId !== null && String(item.seo_id) === String(this.defaultSeoId);
    }

    edit(item:SeoEntity){
        this.title = "Düzenle";
        // Kopya: iptal edilen düzenleme listede kalmasın
        this.data = Object.assign(new SeoEntity(), item);
        this.action = this.baseAction + "/" + item.seo_id;
        this.dialog = true;
    }
    add(){
        this.title = "Ekle";
        this.action = this.baseAction;
        this.data = new SeoEntity();
        this.dialog = true;
    }
    async get(){
        const token = ++this.loadToken;
        this.dialog = false;
        this.loading = true;
        try{
            let response = await this.$http.get(this.baseAction);
            if(token === this.loadToken){
                this.items = Array.isArray(response.data) ? response.data : [];
            }
        }finally {
            if(token === this.loadToken){
                this.loading = false;
            }
        }
    }

    /** Şube değişince liste o şubeye göre yeniden yüklenir; açık form kapatılır */
    @Watch("$store.getters.activeSiteId")
    onActiveSiteChanged(){
        this.dialog = false;
        this.items = [];
        this.get();
    }

    created(){
        this.get();
    }
};
